import React from "react";
import Signup from "./Signup";

const Adminauth = () => {
  return (
    <React.Fragment>
      <Signup />
    </React.Fragment>
  );
};

export default Adminauth;
